import { render, staticRenderFns } from "./RequestOnGoing.vue?vue&type=template&id=915fc008&scoped=true&"
import script from "./RequestOnGoing.vue?vue&type=script&lang=js&"
export * from "./RequestOnGoing.vue?vue&type=script&lang=js&"
import style0 from "./RequestOnGoing.vue?vue&type=style&index=0&id=915fc008&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "915fc008",
  null
  
)

export default component.exports